import { HistoryTableTrack } from '../types/Track';

export const getAircraftSosStatus = (track: HistoryTableTrack): string =>
  `${track.sosStatus[0]}${track.sosStatus.slice(1).toLowerCase()}`;
